import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {AuthService} from '../../../../../firebase/src/lib/services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'lib-promo-code-handler',
  templateUrl: './promo-code-handler.component.html',
  styleUrls: ['./promo-code-handler.component.scss']
})
export class PromoCodeHandlerComponent implements OnInit, OnDestroy {

  @Input() apiUrl = null;
  @Input() userData = null;

  // @ts-ignore
  $subs: Subscription;

  constructor(
      private auth: AuthService,
      private route: ActivatedRoute,
      private router: Router,
      private http: HttpClient
  ) {

  }

  ngOnInit() {
    this.$subs = this.auth.$userState.subscribe(res => {
      if (res) {
        this.requestPromo();
      }
    });
    if (!this.auth.isLoggedIn) {
      this.storePromoId();
    }
  }

  ngOnDestroy() {
    if (this.$subs) {
      this.$subs.unsubscribe();
    }
  }

  storePromoId() {
    const queryParams: any = {...this.route.snapshot?.queryParams};
    if (queryParams?.prId) {
      this.localPromoId = queryParams?.prId;
      delete queryParams.prId;
      this.router.navigate([''], {
        relativeTo: this.route,
        queryParams
      })
          .then(() => {
          });
    }
  }

  requestPromo() {
    this.storePromoId();

    if (this.localPromoId) {
      this.http.post(`${this.apiUrl}/promo`, {promoId: this.localPromoId}, {
        headers: {
          Authorization: `Bearer ${this.auth.userData?.stsTokenManager?.accessToken}`,
        },
        responseType: 'text'
      })
          .subscribe(() => {
            this.localPromoId = null;
            this.$subs.unsubscribe();
          }, (error) => {
            this.localPromoId = null;

            if (error.status === 400) {
              this.localPromoId = null;
            }
          });
    }
  }


  get localPromoId(): any {
    return localStorage.getItem('prId');
  }

  set localPromoId(prop: any) {
    if (prop) {
      localStorage.setItem('prId', prop);
    } else {
      localStorage.removeItem('prId');

    }
  }

}
